import { render, staticRenderFns } from "./ActionCompra.vue?vue&type=template&id=2c3ffa61"
import script from "./ActionCompra.vue?vue&type=script&lang=js"
export * from "./ActionCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports